module.exports = __webpack_public_path__ + "public/files/img/number-form.e61261db.jpg";